'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var util = require('../../helper/util');

/**
 * 柱状图
 */
var ColumnChart = React.createClass({

  render: function () {
    var style = styleHelper.StyleUtil(this.props).bounds().border().style;
    var width = Math.round(style.width * 0.9);
    var height = Math.round(style.height * 0.9);
    var lineWidth = 1;
    var offset = style.height - height - lineWidth;

    var result = graphicsHelper.parseText(styleHelper.getText(this.props), 100);
    var data_arr = result["areas"];
    var color_arr = result["colors"];

    var isShowBorder = (style.borderWidth != "inherit");

    var itemWidth = (width) / data_arr.length;
    var className = "";
    if (isShowBorder) {
      className = "chart-item";
    }

    return (
      <div className="component-SimpleCom component-ColumnChart">
        {
          data_arr.map(function (item, index) {
            var h = Math.round(item / 100 * height * 0.9);
            return (
              <div className={className} style={{
                width:Math.round(itemWidth * 0.75),
                height: h,
                top:height - h + offset,
                left:Math.round(itemWidth*index + itemWidth*0.25),
                backgroundColor:color_arr[index],
                position: 'absolute',
            }}></div>)
          },this)
        }
        {
          this.props.axisvisible &&
          <div className="component-Chart-Coord"></div>
        }
      </div>
    )
  }


});

module.exports = ColumnChart;



// WEBPACK FOOTER //
// ./src/views/Components/ColumnChartEx.jsx